/**
 * URL segments at the site root that map to public document screens (Meta, stores,
 * ad-network reviewers). Each slug here is also statically exported by app/[slug].tsx.
 */

export const LEGAL_ROOT_SLUGS = {
  PRIVACY: 'privacy',
  DATA_DELETION: 'data-deletion',
  TERMS: 'terms',
  CREDITS: 'credits',
  ABOUT: 'about',
  SUPPORT: 'support',
} as const
